(() => {
  "use strict";
  if (window.location.hostname !== "equipment.powerdrivesupply.com" || window.Shopify?.designMode || window.PdsEquipmentTracking) return;
  const seen = new Set();
  let loaded = false;
  const layer = window.dataLayer = window.dataLayer || [];
  function command() { layer.push(arguments); }
  function permissions() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return {
        analytics: privacy?.analyticsProcessingAllowed() === true,
        marketing: privacy?.marketingAllowed() === true,
        sharing: privacy?.saleOfDataAllowed() === true,
      };
    } catch { return { analytics: false, marketing: false, sharing: false }; }
  }
  // Capture the paid arrival before navigation removes its query parameters.
  // Reuse the existing quote payload's storage contract; do not emit a lead here.
  let arrivalCaptured = false;
  function captureArrival() {
    if (arrivalCaptured) return;
    try {
      const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"];
      const clickKeys = ["gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"];
      const url = new URL(window.location.href);
      const parameters = Object.fromEntries(keys.map(key => [key, url.searchParams.get(key) || ""]));
      if (!keys.some(key => parameters[key])) return;
      const sanitize = value => {
        if (!value) return "";
        try {
          const safe = new URL(value, window.location.origin);
          const query = new URLSearchParams();
          keys.forEach(key => { if (safe.searchParams.get(key)) query.set(key, safe.searchParams.get(key)); });
          safe.search = query.toString();
          safe.hash = "";
          return safe.toString();
        } catch { return ""; }
      };
      const touch = {
        ...parameters,
        source: parameters.utm_source || clickKeys.find(key => parameters[key]),
        landing_page: sanitize(url.href),
        referrer: sanitize(document.referrer),
        captured_at: new Date().toISOString(),
      };
      let first;
      try { first = JSON.parse(window.localStorage.getItem("voigt_quote_first_touch_v1")); } catch { /* Treat corrupt storage as absent. */ }
      if (!first || typeof first !== "object" || !first.landing_page) {
        window.localStorage.setItem("voigt_quote_first_touch_v1", JSON.stringify(touch));
      }
      window.localStorage.setItem("voigt_quote_latest_touch_v1", JSON.stringify(touch));
      arrivalCaptured = true;
    } catch { /* Storage and attribution must never prevent consent or quote processing. */ }
  }
  function syncConsent() {
    const allowed = permissions();
    if (allowed.analytics && allowed.marketing) captureArrival();
    if (!loaded && (!allowed.analytics || !allowed.marketing)) return false;
    if (!loaded) {
      command("consent", "default", {
        analytics_storage: "denied", ad_storage: "denied",
        ad_user_data: "denied", ad_personalization: "denied",
      });
    }
    command("consent", "update", {
      analytics_storage: allowed.analytics ? "granted" : "denied",
      ad_storage: allowed.marketing ? "granted" : "denied",
      ad_user_data: allowed.marketing && allowed.sharing ? "granted" : "denied",
      ad_personalization: allowed.marketing && allowed.sharing ? "granted" : "denied",
    });
    if (!loaded) {
      loaded = true;
      layer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-MG7LPS8G";
      document.head.appendChild(script);
    }
    return allowed.analytics && allowed.marketing;
  }
  window.PdsEquipmentTracking = {
    trackLead(quoteRequestId) {
      try {
        if (typeof quoteRequestId !== "string" || !quoteRequestId.trim() || seen.has(quoteRequestId)) return;
        // Do not replay an event that occurred while consent was denied/unknown.
        seen.add(quoteRequestId);
        if (!syncConsent()) return;
        // The ID is used locally for duplicate protection, never sent to Google.
        layer.push({ event: "pds_equipment_quote_accepted" });
      } catch { /* Analytics must never change quote submission outcomes. */ }
    },
  };
  function safelySync() { try { syncConsent(); } catch { /* Fail closed. */ } }
  document.addEventListener("visitorConsentCollected", safelySync);
  if (window.Shopify?.customerPrivacy) safelySync();
  else {
    try {
      window.Shopify?.loadFeatures?.([{ name: "consent-tracking-api", version: "0.1" }], error => {
        if (!error) safelySync();
      });
    } catch { /* Quote processing remains available if privacy loading fails. */ }
  }
})();
